/**
 * Payments
 * Payments APIs
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@generator-strategies/auth-strategy';
import { LanguageStrategy } from '@generator-strategies/language-strategy';
import { TenantStrategy } from '@generator-strategies/tenant-strategy';

// @ts-ignore
import { WebhookControllerWebhookRequest } from '../model/webhookControllerWebhookRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class PersonaPayWebhookService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy,
    @Optional() private readonly languageStrategy: LanguageStrategy,
    @Optional() private readonly tenantStrategy: TenantStrategy,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * @param xRSWebhookEvent
   * @param xRSWebhookId
   * @param xRSOrgId
   * @param xRSConsumerNumber
   * @param webhookControllerWebhookRequest
   */
  public async webhookControllerWebhook(xRSWebhookEvent: string, xRSWebhookId: string, xRSOrgId: string, xRSConsumerNumber: string, webhookControllerWebhookRequest: WebhookControllerWebhookRequest, ): Promise<any> {
    if (xRSWebhookEvent === null || xRSWebhookEvent === undefined) {
      throw new Error('Required parameter xRSWebhookEvent was null or undefined when calling webhookControllerWebhook.');
    }
    if (xRSWebhookId === null || xRSWebhookId === undefined) {
      throw new Error('Required parameter xRSWebhookId was null or undefined when calling webhookControllerWebhook.');
    }
    if (xRSOrgId === null || xRSOrgId === undefined) {
      throw new Error('Required parameter xRSOrgId was null or undefined when calling webhookControllerWebhook.');
    }
    if (xRSConsumerNumber === null || xRSConsumerNumber === undefined) {
      throw new Error('Required parameter xRSConsumerNumber was null or undefined when calling webhookControllerWebhook.');
    }
    if (webhookControllerWebhookRequest === null || webhookControllerWebhookRequest === undefined) {
      throw new Error('Required parameter webhookControllerWebhookRequest was null or undefined when calling webhookControllerWebhook.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xRSWebhookEvent) {
      localVarHeaders['X-RS-WebhookEvent'] = String(xRSWebhookEvent);
    }
    if (xRSWebhookId) {
      localVarHeaders['X-RS-WebhookId'] = String(xRSWebhookId);
    }
    if (xRSOrgId) {
      localVarHeaders['X-RS-OrgId'] = String(xRSOrgId);
    }
    if (xRSConsumerNumber) {
      localVarHeaders['X-RS-ConsumerNumber'] = String(xRSConsumerNumber);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/payments/persona-pay/webhook`,
        data: webhookControllerWebhookRequest,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
